import angular from "angular";

export default class ListViewCtrl {

  constructor(itemSource){
    this.itemSource = itemSource;
    this.filter = angular.copy(itemSource.filter);
  }

  getEmptyFilter(){
    return {
    };
  }

  resetFilter(){
    this.filter = this.getEmptyFilter();
    this.load();
  }

  isFilterActive(){
    const empty = this.getEmptyFilter();
    const filter = this.itemSource.filter;
    return Object.keys(filter).map(key => filter[key] !== empty[key]).reduce((a,b) => (a||b), false);
  }

  load(){
    this.itemSource.filter = angular.copy(this.filter);
    return this.itemSource.load();
  }

}


// WEBPACK FOOTER //
// ./src/util/ListViewCtrl.js